import React, { useState } from "react";
import { useAppDispatch } from "../../../../../redux/hooks";
import CustomButton from "../../../../../components/CustomButton";
import {
  getActivateDeliveryArrangement,
  getDeliveryArrangement,
  postCancelAwb,
  postChangeClient,
} from "../../../../../redux/api/picking.api";
import { getSyncronizeInvoices } from "../../../../../redux/api/external.api";
import { pickingRoutes } from "../../../../../router/routesConstants";
import SvgIcon from "../../../../../helpers/SvgIcon";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";
import { dateForDatabase } from "../../../../../utils/dateAndTime";
import {
  openChangeDateDeliveryArrangementModal,
  setSelectedPackageChangingDate,
} from "../../../../../redux/reducer/picking.reducer";

function DeliveryArrangementActionButton(props: any) {
  const dispatch = useAppDispatch();
  const { isAuthorized } = usePermissions();

  const [isLoading, setIsLoading] = useState(false);

  const formatDate = dateForDatabase(props.tableContext.tableSearch?.createdAt);

  const handleActivateDeliveryArrangement = () => {
    setIsLoading(true);

    dispatch(
      getActivateDeliveryArrangement({
        params: {
          op: props.crudData.Op,
          page: props.tableContext.tablePagination.page,
          perPage: props.tableContext.tablePagination.rowsPerPage,
          status: props.tableContext.tableSearch?.status ?? 0,
          facturi: props.tableContext.tableSearch?.facturi,
          ruta: props.tableContext.tableSearch?.ruta,
          deliveryPoint: props.tableContext.tableSearch?.deliveryPoint,
        },
        callBack: () => {
          dispatch(
            getDeliveryArrangement({
              page: props.tableContext.tablePagination.page,
              perPage: props.tableContext.tablePagination.rowsPerPage,
              status: props.tableContext.tableSearch?.status ?? 0,
              facturi: props.tableContext.tableSearch?.facturi ?? "",
              ruta: props.tableContext.tableSearch?.ruta ?? "",
              deliveryPoint:
                props.tableContext.tableSearch?.deliveryPoint ?? "",
              commandNumber:
                props.tableContext.tableSearch?.commandNumber ?? "",
              createdAt: formatDate,
            }),
          );
          setIsLoading(false);
        },
      }),
    );
  };

  const handleSyncronizeInvoices = () => {
    dispatch(
      getSyncronizeInvoices({
        op: props.crudData.Op,
      }),
    );
  };

  const handleChangeDeliveryPoint = async () => {
    if (!props.crudData.Op) {
      return;
    }

    setIsLoading(true);

    const resultAction = await dispatch(
      postChangeClient({
        op: props.crudData.Op,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postChangeClient) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postChangeClient) ===
      endpointStatus.fulfilled
    ) {
      setIsLoading(false);

      dispatch(
        getDeliveryArrangement({
          page: props.tableContext.tablePagination.page,
          perPage: props.tableContext.tablePagination.rowsPerPage,
          status: props.tableContext.tableSearch?.status ?? 0,
          facturi: props.tableContext.tableSearch?.facturi ?? "",
          ruta: props.tableContext.tableSearch?.ruta ?? "",
          deliveryPoint: props.tableContext.tableSearch?.deliveryPoint ?? "",
          commandNumber: props.tableContext.tableSearch?.commandNumber ?? "",
          createdAt: formatDate,
        }),
      );
    }
  };

  const handleCancelAwb = async () => {
    setIsLoading(true);

    const resultAction = await dispatch(
      postCancelAwb({
        doc_trans: props.crudData.doc_trans,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postCancelAwb) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postCancelAwb) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        getDeliveryArrangement({
          page: props.tableContext.tablePagination.page,
          perPage: props.tableContext.tablePagination.rowsPerPage,
          status: props.tableContext.tableSearch?.status ?? 0,
          facturi: props.tableContext.tableSearch?.facturi ?? "",
          ruta: props.tableContext.tableSearch?.ruta ?? "",
          deliveryPoint: props.tableContext.tableSearch?.deliveryPoint ?? "",
          commandNumber: props.tableContext.tableSearch?.commandNumber ?? "",
          createdAt: formatDate,
        }),
      );
    }
  };

  const handleChangePickingDate = () => {
    dispatch(setSelectedPackageChangingDate(props.crudData));
    dispatch(openChangeDateDeliveryArrangementModal());
  };

  return (
    <div>
      {props.crudData.status <= 1 && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          loading={isLoading}
          color={props.crudData.status === 0 ? "success" : "warning"}
          tooltipTitle={`${
            props.crudData.status === 0 ? "Activati" : "Dezactivati"
          }`}
          withConfirmationModal={{
            modalLeftButtonVariant: "outlined",
            modalTitle: `Doriti sa ${
              props.crudData.status === 0 ? "activati" : "dezactivati"
            } comanda nr: ${props.crudData.id}?`,
            modalRightButtonOnClick: handleActivateDeliveryArrangement,
          }}>
          <SvgIcon type="ACTIVATE" fill="white" className="svg-icon-3" />
        </CustomButton>
      )}
      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        loading={isLoading}
        tooltipTitle="Resincronizati"
        withConfirmationModal={{
          modalLeftButtonVariant: "outlined",
          modalTitle: `Doriti sa resincronizati facturile din comanda nr: ${props.crudData.id}?`,
          modalRightButtonOnClick: handleSyncronizeInvoices,
        }}>
        <SvgIcon type="RESYNC" fill="white" className="svg-icon-3" />
      </CustomButton>

      <CustomButton
        variant="contained"
        className="mt-1 me-1"
        loading={isLoading}
        tooltipTitle="Split"
        navigate={`/${pickingRoutes.picking}/${pickingRoutes.splitInvoices}?delivery=${props.crudData.pctDeLivr}&op=${props.crudData.Op}&status=${props.crudData.status}`}>
        <SvgIcon type="SPLIT_LIST" />
      </CustomButton>

      {isAuthorized(userRoles.CHANGE_DELIVERY_POINT) && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          loading={isLoading}
          tooltipTitle="Schimbare punct de livrare"
          withConfirmationModal={{
            modalLeftButtonVariant: "outlined",
            modalTitle: `Doriti sa schimbati punctul de livrare al clientului pentru comanda nr: ${props.crudData.Op}?`,
            modalRightButtonOnClick: handleChangeDeliveryPoint,
          }}>
          <SvgIcon type="CHANGE_ROUTE" fill="white" className="svg-icon-3" />
        </CustomButton>
      )}

      {props.crudData.doc_trans && (
        <CustomButton
          variant="contained"
          className="mt-1 me-1"
          tooltipTitle="Schimbare data ridicarii coletului"
          onClick={handleChangePickingDate}>
          <SvgIcon type="CHANGE_DATE" className="svg-icon-2" fill="white" />
        </CustomButton>
      )}

      {props.crudData.doc_trans && (
        <CustomButton
          loading={isLoading}
          className="mt-1 me-1"
          variant="contained"
          color="error"
          tooltipTitle="Anuleaza AWB"
          withConfirmationModal={{
            modalTitle: "Anuleaza AWB",
            modalSubtitle: `Doriti sa anulati awb-ul ${props.crudData.doc_trans}?`,
            modalLeftButtonVariant: "outlined",
            modalRightButtonOnClick: handleCancelAwb,
          }}>
          <SvgIcon type="CANCEL" className="svg-icon-2" fill="white" />
        </CustomButton>
      )}
    </div>
  );
}

export default DeliveryArrangementActionButton;
